<template>
  <v-row v-resize="onResizeWindow">
    <v-col class="px-1">
      <v-card>
        <v-card-title class="display-1">
          Готовые к покупке
        </v-card-title>
        <v-card-text class="px-1">
          <v-data-table
            class="elevation-1"
            :items="cartOfGoods"
            :headers="headers"
            :options="options"
            hide-default-footer
            :items-per-page="-1"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:body.append>
              <tr>
                <td v-if="!isMobile" />
                <td v-if="!isMobile" />
                <td v-text="'Итого'" />
                <td>
                  <v-chip color="success">
                    {{ Number(total).money() }}
                  </v-chip>
                </td>
              </tr>
            </template>
            <template v-slot:item.action="{item}">
                <v-icon large @click="onDeleteItem(item)">
                  mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.cost="{item}">
              {{ Number(item.cost).money() }}
            </template>
            <template v-slot:item.price="{item}">
              {{ Number(item.price).money() }}
            </template>
            <template v-slot:item.amount="{item}">
              <td class="d-flex flex-nowrap justify-space-between pr-0">
                  <v-icon x-large @click="onMinusCounter(item)">mdi-minus-circle-outline</v-icon>
              <v-text-field outlined :value="item.amount" hide-details dense readonly ></v-text-field>
                <v-icon x-large @click="onAddCounter(item)">mdi-plus-circle-outline</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-space-around">
          <v-btn
            color="primary"
            outlined
            @click="onShop"
          >
            Назад
          </v-btn>
          <v-btn
            color="primary"
            @click="onPay"
          >
            Оплатить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script >
export default {
  name: "ConfigurationCartScreen",
  props: {
    cart: Array
  },
  data: () => ({
    cartOfGoods: [],
    isMobile: false,
    isWider: false,
    headers: [
      { text: "Наименование", value: "nomenclatureName", sortable: false, width: "75px" },
      { text: "Цена", value: "price", sortable: false, },
      { text: "Количество", value: "amount", sortable: false },
      { text: "Сумма", value: "cost", sortable: false },
      { text: "Удалить", value: "action", sortable: false }
    ],
    options: {
      itemsPerPage: 100,
      mustSort: false,
      sortBy: []
    }
  }),
  computed: {
    total () {
      return this.cartOfGoods.reduce((acc, c) => acc + c.cost, 0)
    }
  },
  watch: {
    cart(newValue) {
      this.cartOfGoods = this.cart
    },
    deep:true,
  },
  mounted () {
    this.cartOfGoods = this.cart
  },
  methods: {
    onAddCounter (item) {
      console.log('onAddCounter', item)
      if (this.cartOfGoods.length > 0) {
        this.cartOfGoods = this.cartOfGoods.map(c => {
          if (c.nomenclatureId === item.nomenclatureId) {
            c.amount += 1
            c.cost = c.amount * item.price
          }
          return c
        })
      }
      this.$emit('change', item)
    },
    onDeleteItem(item) {
      if (this.cartOfGoods.length > 0) {
        this.cartOfGoods = this.cartOfGoods.filter(c =>
          c.nomenclatureId !== item.nomenclatureId
        )
        console.log('onDeleteItem cartOfGoods', this.cartOfGoods)
        this.$emit('delete',this.cartOfGoods, item)
      }
    },
    onMinusCounter (item) {
      if (this.cartOfGoods.length > 0) {
        this.cartOfGoods = this.cartOfGoods.map(c => {
          if (c.nomenclatureId === item.nomenclatureId) {
            if (c.amount > 1) {
              c.amount -= 1
              c.cost = c.amount * item.price
            }
          }
          return c
        })
      }
      this.$emit('change', item)
    },
    onPay () {
      this.$emit("pay")
    },
    onResizeWindow () {
      const windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.isWider = windowSize.x > windowSize.y
      this.isMobile = windowSize.x < 600
    },
    onShop () {
      this.$emit("shop")
    }
  }

}

</script>
<style>
 input {
  text-align: center;
}

.v-data-table__mobile-table-row {
  width: 100% !important;
}
.v-data-table__mobile-row {
  width: 100% !important;
}
.v-data-table .v-data-table__mobile-table-row {
  width: 100%  !important;
}
.v-data-table .v-data-table__mobile-row {
  width: 100%  !important;
}
td .v-data-table__mobile-row {
  width: 100%  !important;
}

</style>
